import React from 'react';
import { find, capitalize } from 'lodash';
import Select from 'react-select';
import FormLabel from './FormLabel';

const FormSelect = ({
  name,
  value,
  label = capitalize(name),
  onFieldChange,
  onChange = (value) => onFieldChange(name, value.value),
  options
}) => (
  <FormLabel {...{ name, label }}>
    <Select
      name={name}
      options={options}
      value={find(options, ['value', value])}
      onChange={onChange} />
  </FormLabel>
)

export default FormSelect
